export const setMaxAttributes = (menuResponse:any)=>{
     window.orderViewModel.store.storeMainItemsThreshold = menuResponse && menuResponse.storeMainItemsThreshold ;
     window.orderViewModel.store.storeSubItemsThreshold =  menuResponse && menuResponse.storeSubItemsThreshold;
     window.orderViewModel.save();
}
export const setMaxLimit = (categoryCheck:any)=>{
    return categoryCheck ? window.orderViewModel.store.storeSubItemsThreshold: window.orderViewModel.store.storeMainItemsThreshold;
}